const options = [
  {
    value: '行政單位',
    label: '行政單位',
    children: [
      {
        value: '校長室',
        label: '校長室',
        build: '行政大樓 3F',
      },
      {
        value: '副校長室',
        label: '副校長室',
        build: '行政大樓 3F',
      },
      {
        value: '秘書室',
        label: '秘書室',
        build: '行政大樓 3F',
      },
      {
        value: '推廣教育處',
        label: '推廣教育處',
        build: '真知教學大樓 9F',
      },
      {
        value: '軍訓室',
        label: '軍訓室',
        build: '維澈樓 3F',
      },
      {
        value: '校友服務暨資源發展處',
        label: '校友服務暨資源發展處',
        build: '維澈樓 2F',
      },
      {
        value: '體育室',
        label: '體育室',
        build: '體育館',
      },
      {
        value: '教務處',
        label: '教務處',
        build: '維澈樓 4F',
      },
      {
        value: '學務處',
        label: '學務處',
        build: '維澈樓 3F',
      },
      {
        value: '總務處',
        label: '總務處',
        build: '維澈樓 5F',
      },
      {
        value: '人事室',
        label: '人事室',
        build: '維澈樓 7F',
      },
      {
        value: '會計室',
        label: '會計室',
        build: '維澈樓 6F',
      },
      {
        value: '研發處',
        label: '研發處',
        build: '維澈樓 6F',
      },
      {
        value: '招生事務處',
        label: '招生事務處',
        build: '維澈樓',
      },
      {
        value: '校牧處',
        label: '校牧處',
        build: '全人教育村 中棟 1F',
      },
      {
        value: '張靜愚紀念圖書館',
        label: '張靜愚紀念圖書館',
        build: '圖書館',
      },
      {
        value: '電子計算機中心',
        label: '電子計算機中心',
        build: '真知教學大樓 7F',
      },
      {
        value: '產學營運處',
        label: '產學營運處',
        build: '產學大樓',
      },
      {
        value: '環境保護暨安全衛生中心',
        label: '環境保護暨安全衛生中心',
        build: '維澈樓 5F',
      },
      {
        value: '國際暨兩岸教育處',
        label: '國際暨兩岸教育處',
        build: '維澈樓 7F',
      },
      {
        value: '校務研究暨永續發展處',
        label: '校務研究暨永續發展處',
        build: '行政大樓 2F',
      },
      {
        value: '職涯發展處',
        label: '職涯發展處',
        build: '維澈樓 7F',
      },
      {
        value: '數位教育發展處',
        label: '數位教育發展處',
        build: '圖書館',
      },
    ],
  },
  {
    value: '學術單位',
    label: '學術單位',
    children: [
      // -------------------------------- 理學院
      {
        value: '理學院',
        label: '理學院',
        disabled: true,
      },
      {
        value: '理學院 辦公室',
        label: '理學院 辦公室',
        build: '管理大樓',
      },
      {
        value: '應用數學系',
        label: '應用數學系',
        build: '科學館',
      },
      {
        value: '物理學系',
        label: '物理學系',
        build: '科學館',
      },
      {
        value: '化學系',
        label: '化學系',
        build: '理學大樓',
      },
      {
        value: '心理學系',
        label: '心理學系',
        build: '科學館',
      },
      {
        value: '生物科技學系',
        label: '生物科技學系',
        build: '生科館',
      },
      // -------------------------------- 工學院
      {
        value: '工學院',
        label: '工學院',
        disabled: true,
      },
      {
        value: '工學院 辦公室',
        label: '工學院 辦公室',
        build: '工學館',
      },
      {
        value: '化學工程學系',
        label: '化學工程學系',
        build: '理學大樓',
      },
      {
        value: '土木工程學系',
        label: '土木工程學系',
        build: '土木館',
      },
      {
        value: '機械工程學系',
        label: '機械工程學系',
        build: '工學館',
      },
      {
        value: '生物醫學工程學系',
        label: '生物醫學工程學系',
        build: '工學館',
      },
      {
        value: '環境工程學系',
        label: '環境工程學系',
        build: '生科館',
      },
      // -------------------------------- 電機資訊學院
      {
        value: '電機資訊學院',
        label: '電機資訊學院',
        disabled: true,
      },
      {
        value: '電機資訊學院 辦公室',
        label: '電機資訊學院 辦公室',
        build: '電學大樓',
      },
      {
        value: '工業與系統工程學系',
        label: '工業與系統工程學系',
        build: '莊敬大樓',
      },
      {
        value: '電子工程學系',
        label: '電子工程學系',
        build: '篤信大樓',
      },
      {
        value: '資訊工程學系',
        label: '資訊工程學系',
        build: '電學大樓',
      },
      {
        value: '電機工程學系',
        label: '電機工程學系',
        build: '電學大樓',
      },
      {
        value: '智慧運算與量子資訊學院',
        label: '智慧運算與量子資訊學院',
        build: '知行領航館',
      },
      {
        value: '半導體產業學院',
        label: '半導體產業學院',
        build: '知行領航館',
      },
      // -------------------------------- 商學院
      {
        value: '商學院',
        label: '商學院',
        disabled: true,
      },
      {
        value: '商學院 辦公室',
        label: '商學院 辦公室',
        build: '管理大樓',
      },
      {
        value: '企業管理學系',
        label: '企業管理學系',
        build: '商學自強大樓',
      },
      {
        value: '國際經營與貿易學系',
        label: '國際經營與貿易學系',
        build: '商學自強大樓',
      },
      {
        value: '會計學系',
        label: '會計學系',
        build: '商學自強大樓',
      },
      {
        value: '資訊管理學系',
        label: '資訊管理學系',
        build: '資管樓',
      },
      {
        value: '財務金融學系',
        label: '財務金融學系',
        build: '商學自強大樓',
      },
      // -------------------------------- 法學院
      {
        value: '法學院',
        label: '法學院',
        disabled: true,
      },
      {
        value: '法學院 辦公室',
        label: '法學院 辦公室',
        build: '全人村',
      },
      {
        value: '財經法律學系',
        label: '財經法律學系',
        build: '全人村',
      },
      // -------------------------------- 設計學院
      {
        value: '設計學院',
        label: '設計學院',
        disabled: true,
      },
      {
        value: '設計學院 辦公室',
        label: '設計學院 辦公室',
        build: '設計學院',
      },
      {
        value: '建築學系',
        label: '建築學系',
        build: '建築館',
      },
      {
        value: '室內設計學系',
        label: '室內設計學系',
        build: '室設館',
      },
      {
        value: '商業設計學系',
        label: '商業設計學系',
        build: '商設館',
      },
      {
        value: '地景建築系',
        label: '地景建築系',
        build: '景館樓',
      },
      // -------------------------------- 人文與教育學院
      {
        value: '人文與教育學院',
        label: '人文與教育學院',
        disabled: true,
      },
      {
        value: '人文與教育學院 辦公室',
        label: '人文與教育學院 辦公室',
        build: '全人村',
      },
      {
        value: '特殊教育學系',
        label: '特殊教育學系',
        build: '全人村',
      },
      {
        value: '應用外國語文學系',
        label: '應用外國語文學系',
        build: '全人村',
      },
      {
        value: '應用華語文學系',
        label: '應用華語文學系',
        build: '全人村',
      },
    ],
  },
];

export default options;
